import { render } from "./questions.vue?vue&type=template&id=fd694b64"
import script from "./questions.vue?vue&type=script&lang=js"
export * from "./questions.vue?vue&type=script&lang=js"

import "./questions.vue?vue&type=style&index=0&id=fd694b64&lang=scss&scope=true"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/adQuestionsPop/questions.vue'],['render',render],['__file',"questions.vue"]])

export default __exports__